(function() {
    'use strict';

    angular
        .module('pwc.controllers')
        .controller('WinesPrintController', WinesPrintController);

    WinesPrintController.$inject = ['$rootScope', 'userPouch', '$state', '$window', 'lodash', 'Wine', '$log', 'BarcodeFactory', 'UserService', 'Utils'];

    function WinesPrintController($rootScope, userPouch, $state, $window, lodash, Wine, $log, BarcodeFactory, UserService, Utils){

        /* jshint validthis: true */
        var self = this;

        self.wine = {};

        self.data = null;

        self.combinedHistory = null;

        self.settings = {
            "fontSize": 13,
            "history": true
        };

        self.browserPrint = browserPrint;
        self.returnToWine = returnToWine;

        /** initialize */

        initialize();

        /** begin methods */

        function initialize(){
            showWine();
        }

        function prepPrintData(){
            var rows = [
                {
                    label: 'Producer',
                    value: lodash.get(self.wine, 'producer.name')
                },
                {
                    label: 'Name',
                    value: lodash.get(self.wine, 'name')
                },
                {
                    label: 'Vintage',
                    value: lodash.get(self.wine, 'vintage')
                },
                {
                    label: 'Region',
                    value: self.wine.getFullAppellation()
                },
                {
                    label: 'Quantity',
                    value: lodash.get(self.wine, 'cellar.qty', 0)
                },
                {
                    label: 'Quantity On Order',
                    value: self.wine.getOnOrderQty() > 0 ? self.wine.getOnOrderQty() : null
                },
                {
                    label: 'Location',
                    value: lodash.get(self.wine, 'cellar.location')
                },
                {
                    label: 'Value (per bottle)',
                    value: Utils.formatCurrencyShort(lodash.get(self.wine, 'cellar.value'))
                },
                {
                    label: 'Total Value',
                    value: Utils.formatCurrencyShort(lodash.get(self.wine, 'cellar.totalValue'))
                },
                {
                    label: 'ID #',
                    value: lodash.get(self.wine, 'cellar.id')
                },
                {
                    label: 'Custom/Alt ID #',
                    value: lodash.get(self.wine, 'cellar.ids.custom')
                },
                {
                    label: 'Barcode',
                    value: lodash.get(self.wine, 'cellar.ids.barcode')
                },
                {
                    label: 'Varietal',
                    value: lodash.get(self.wine, 'varietal.name')
                },
                {
                    label: 'Distinction',
                    value: lodash.get(self.wine, 'distinction.name')
                },
                {
                    label: 'Type',
                    value: lodash.get(self.wine, 'category.name')
                },
                {
                    label: 'Body',
                    value: lodash.get(self.wine, 'body')
                },
                {
                    label: 'Vineyard',
                    value: lodash.get(self.wine, 'vineyard.name')
                },
                {
                    label: 'Maker',
                    value: lodash.get(self.wine, 'maker.name')
                },
                {
                    label: 'Website',
                    value: lodash.get(self.wine, 'url')
                },
                {
                    label: 'Grapes',
                    value: self.wine.grapeSummary()
                },
                {
                    label: 'Bottle Size',
                    value: lodash.get(self.wine, 'bottleSize.name')
                },
                {
                    label: 'ABV %',
                    value: lodash.get(self.wine, 'abv')
                },
                {
                    label: 'Cases Produced',
                    value: lodash.get(self.wine, 'cases')
                },
                {
                    label: 'Drink After',
                    value: lodash.get(self.wine, 'cellar.aging.after')
                },
                {
                    label: 'Drink By',
                    value: lodash.get(self.wine, 'cellar.aging.by')
                },
                {
                    label: 'Notes',
                    value: lodash.get(self.wine, 'notes')
                },
                {
                    label: 'My Rating',
                    value: lodash.get(self.wine, 'rating.user.general')
                },
                {
                    label: 'My 100 pt Rating',
                    value: lodash.get(self.wine, 'rating.user.point')
                },
                {
                    label: 'Wine Advocate',
                    value: lodash.get(self.wine, 'rating.other.advocate')
                },
                {
                    label: 'Wine Enthusiast',
                    value: lodash.get(self.wine, 'rating.other.enthusiast')
                },
                {
                    label: 'Wine Spectator',
                    value: lodash.get(self.wine, 'rating.other.spectator')
                },
                {
                    label: 'Vinous',
                    value: lodash.get(self.wine, 'rating.other.vinous')
                },
                {
                    label: 'James Suckling',
                    value: lodash.get(self.wine, 'rating.other.suckling')
                },
            ];

            if (lodash.get(self.wine, 'custom')){
                lodash.each(self.wine.custom, function(item){
                    rows.push(item);
                });
            }

            rows = lodash.filter(rows, function(item){
                return lodash.isNotEmptyOrNull(item.value);
            });

            self.data = rows;
        }

        function returnToWine(){
            Utils.go('wines/edit', {id: self.wine['_id']});
        }

        function browserPrint(){
            $window.print();
        }

        function showWine(){

            var wineId = lodash.get(self.wine, '_id', $state.params.id.toString());

            if (lodash.isEmptyOrNull(wineId))
            {
                $log.debug('No wine to show!');
                return false;
            }

            $log.debug('Showing wine', wineId);

            return userPouch.db().get(wineId, {conflicts: true})
                .then(function (wine) {
                    $log.debug('Got Wine', wine);

                    self.wine = new Wine(wine);
                    $rootScope.layout.setPageTitle(self.wine.getFullName());

                    _showHistory();

                    if (lodash.get(wine, '_attachments')) {
                        return userPouch.db().getAttachment(self.wine['_id'], 'thumbnail.jpg').then(function (blob) {
                            self.thumbnail = URL.createObjectURL(blob);
                            return self.wine;
                        }).catch(function (err) {
                            $log.error('Error getting thumb', err);
                        });
                    }

                    prepPrintData();

                    return self.wine;
                })
                .then(function(wine){
                    return _writeBarcode(false, false);
                })
                .then(_addCustomFields);
        }

        /**
         * Updates history which is generated when showing a wine and/or editing in dialogs.
         *
         * @private
         */
        function _showHistory(){

            $log.debug('Showing history...');

            self.combinedHistory = self.wine.getCombinedHistory();
        }

        function _addCustomFields(){

            UserService.getSetting('customFields').then(function(customFields){

                $log.debug('User Setting: customFields', customFields);

                if (lodash.isEmptyOrNull(self.wine.custom)){
                    self.wine.custom = [];
                }

                lodash.forEach(customFields, function(customField){
                    var exists = lodash.findWhere(self.wine.custom, { "label": customField });
                    if (! exists){
                        self.wine.custom.push({
                            "label": customField,
                            "value": null
                        });
                    }
                });
            });
        }

        function _writeBarcode(){

            $log.debug('Writing barcode...');

            var currentBarcode = lodash.get(self.wine, 'cellar.ids.barcode');

            if (! currentBarcode || currentBarcode.length < 11){
                return null;
            }

            $log.debug('Generating barcode from:', currentBarcode);

            return new BarcodeFactory(currentBarcode)
                .then(function(barcode){
                    // update the model in case check sum wasn't sent from model data (Barcode Service calculates it if necessary)
                    lodash.set(self.wine, 'cellar.ids.barcode', barcode);
                })
                .catch(function(e){
                    // clear any prior canvas barcode
                    var canvas = document.getElementById("canvas");
                    var ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                });
        }
    }

})();
